var map = {
	"./cover.jpg": "d4f6",
	"./user-01.jpg": "2b0b",
	"./user-02.jpg": "fb18",
	"./user-03.jpg": "2b98",
	"./user-04.jpg": "a83b",
	"./user-05.jpg": "6055d",
	"./user-06.jpg": "8043",
	"./user-07.jpg": "f583",
	"./user-08.jpg": "cc14",
	"./user-09.jpg": "adfa",
	"./user-10.jpg": "9e61",
	"./user-11.jpg": "9357",
	"./user-12.jpg": "3cda",
	"./user-13.jpg": "0031",
	"./user-14.png": "1144"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "367b";